// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { GetWishListsApiParameter } from "@insite/client-framework/Services/WishListService";
import {
    chain,
    DispatchLoadWishListLinesIfNeeded,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListIfNeeded";
import loadWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import updateLoadWishListLinesParameter from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateLoadWishListLinesParameter";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    { wishListId: string; includeAttributes?: boolean },
    GetWishListsApiParameter,
    OrderModel
>;

export const XngDispatchLoadWishListLinesIfNeeded: HandlerType = props => {
    const loadWishListLinesParameter = {
        wishListId: props.parameter.wishListId,
        defaultPageSize: props.getState().context.settings.settingsCollection.wishListSettings.productsPerPage,
        query: "",
    } as any;

    props.parameter.includeAttributes ? (loadWishListLinesParameter.includeAttributes = true) : null;

    props.dispatch(
        updateLoadWishListLinesParameter({
            ...loadWishListLinesParameter,
        } as any),
    );

    props.dispatch(loadWishListLines());
};

replaceInChain(chain, DispatchLoadWishListLinesIfNeeded, XngDispatchLoadWishListLinesIfNeeded);
